var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', {
    staticClass: "is-loading"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "app-datetime-picker"
  }, [_c('AppDatePicker', {
    attrs: {
      "hasError": _vm.hasError,
      "placeholder": _vm.placeholderForDate,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  }), _c('AppTimePicker', {
    attrs: {
      "hasError": _vm.hasError,
      "placeholder": _vm.placeholderForTime,
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.handleInput
    },
    model: {
      value: _vm.time,
      callback: function callback($$v) {
        _vm.time = $$v;
      },
      expression: "time"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }